import { createSlice } from '@reduxjs/toolkit';
import { Modal } from 'antd';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

const initialState = {
  id: '',
  username: '',
  fullname: '',
  role_id: '',
  isAuthenticated: !!Cookies.get('access_token'),
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    signIn: (state, action) => {
      const { accessToken, refreshToken } = action.payload;
      const decodedAccessToken = jwtDecode(accessToken);
      const decodedRefreshToken = jwtDecode(refreshToken);
      const expAccessToken = decodedAccessToken.exp;
      const expRefreshToken = decodedRefreshToken.exp;

      Cookies.set('access_token', accessToken, {
        expires: new Date(expAccessToken * 1000),
        // secure: true,
        sameSite: 'Strict',
        // httpOnly: true,
      });

      Cookies.set('refresh_token', refreshToken, {
        expires: new Date(expRefreshToken * 1000),
        // secure: true,
        sameSite: 'Strict',
      });

      state.isAuthenticated = true;
    },
    updateUser: (state, action) => {
      const newData = { ...state, ...action.payload };

      // remove tokens from newData
      const { accessToken, refreshToken, ...userData } = newData;

      localStorage.setItem('user', JSON.stringify(userData));
      return userData;
    },
    logOut: (state) => {
      Modal.destroyAll();
      localStorage.removeItem('user');
      Cookies.remove('access_token'); // auto navigate when this cookie is removed
      Cookies.remove('refresh_token');

      state.isAuthenticated = false;
    },
  },
});

export const {
  signIn: signInAction,
  updateUser: updateUserAction,
  logOut: logOutAction,
} = userSlice.actions;
export const selectUser = (state) => state.user;

export default userSlice.reducer;
